import { createElement, FC, memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import core, { App, View } from '@gin-betting/core';

import globalMsgs from 'messages';
import { getRouteBySportType } from 'utils';

const {
    utils: { getBettingOptions, getSportTypeBySport, checkOnRoute },
    components: { SportEventSeoMicromarking: BaseSportEventSeoMicromarking },
} = core;

const SportEventSeoMicromarking: FC<{ sportEventId: string }> = ({
    sportEventId,
}) => {
    const { formatMessage } = useIntl();

    const getHelmetScript = useCallback(
        ({ sportEvent, sport }) => {
            const { title, startTime, slug } = sportEvent;
            const { name: sportName } = sport;

            const url = makeAbsoluteMatchUrl(sport, slug);

            const name =
                getLocationNameByRoute(formatMessage)?.toLowerCase() ||
                sportName;

            return [
                {
                    type: 'application/ld+json',
                    innerHTML: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'SportsEvent',
                        name: title,
                        startDate: startTime,
                        url,
                        location: {
                            '@type': 'Place',
                            name,
                            address: { '@type': 'PostalAddress', name: '' },
                        },
                    }),
                },
            ];
        },
        [formatMessage]
    );

    return createElement(BaseSportEventSeoMicromarking, {
        sportEventId,
        getHelmetScript,
    });
};

export default memo(SportEventSeoMicromarking);

function makeAbsoluteMatchUrl(sport: View.Sport, matchSlug: string): string {
    let {
        url: { bettingPath },
    } = getBettingOptions();

    // Avoid double slash when joined
    if (bettingPath === '/') {
        bettingPath = '';
    }

    const sportType = getRouteBySportType(getSportTypeBySport(sport));

    return [
        location.origin,
        bettingPath,
        sportType,
        App.Routes.MATCH,
        matchSlug,
    ].join('');
}

function getLocationNameByRoute(
    formatMessage: ReturnType<typeof useIntl>['formatMessage']
): string | null {
    switch (true) {
        case checkOnRoute(App.Routes.CLASSIC, { exact: true }): {
            return formatMessage(globalMsgs.csport);
        }

        case checkOnRoute(App.Routes.ESPORT, { exact: true }): {
            return formatMessage(globalMsgs.esport);
        }

        default: {
            return null;
        }
    }
}
